import { render } from "./ExpiredFireCert.vue?vue&type=template&id=dcfb5e2c"
import script from "./ExpiredFireCert.vue?vue&type=script&lang=js"
export * from "./ExpiredFireCert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__